import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'relative z-0',
    wrapper:
      'invalid:border-bg-delete-error relative inline-flex w-full flex-wrap items-center border-b-1 border-black',
    label: 'sr-only',
    input:
      'peer invalid:text-error placeholder:text-secondary-hover disabled:placeholder:text-inactive disabled:text-inactive block w-25 min-w-0 flex-1 appearance-none px-3 pt-3 pb-3 focus:outline-none',
    helperText: 'text-inactive heading-s px-3 pt-1',
    startAdornment: 'absolute top-1/2 left-0 h-6 -translate-y-1/2 pl-3',
    endAdornment: 'h-6 pr-3',
    inputWrapper: 'inline-flex grow items-center justify-between'
  },
  variants: {
    withStartAdornment: {
      true: {
        input: 'pl-12'
      }
    }
  }
});
